import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  selectButton: {
    height: pxToRem(25),
    width: pxToRem(40),
    fontSize: pxToRem(16),
    textAlign: 'center',
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    fontSize: pxToRem(16),
    textAlign: 'center',
    color: theme.palette.neutralTertiary,
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(16),
        width: pxToRem(32),
        textAlign: 'left',
        fontSize: pxToRem(14),
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        verticalAlign: 'middle',
      },
    },
  },
  extraColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(16),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: pxToRem(16),
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        verticalAlign: 'middle',
        paddingLeft: '8px',
      },
    },
  },
  infoIcon: {
    position: 'relative',
    fontSize: pxToRem(16),
    marginLeft: pxToRem(5),
    marginTop: pxToRem(2),
    float: 'right',
    color: theme.palette.themePrimary,
  },

  associatedContractStatusIcon: {
    marginRight: pxToRem(8),
    color: theme.palette.yellowDark,
    fontSize: pxToRem(18),
  },
  viewLink: {
    float: 'right',
    marginRight: pxToRem(16),
  },
  listData: {
    height: pxToRem(20),
    width: pxToRem(320),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
    color: theme.palette.neutralDark,
  },
});
